<nav
  class="navbar navbar-expand-lg navbar-dark"
>
  <!-- Mobile Brand and Toggler wrapper (forced nowrap) -->
  <div class="d-flex justify-content-between align-items-center w-100 d-lg-none flex-nowrap">
    <a class="navbar-brand mr-0 text-truncate" href="/" style="min-width: 0;">
      <img src="/assets/nztcs_logo.png" class="logo" alt="New Zealand Threat Classification System" title="New Zealand Threat Classification System" style="max-width: 100%; height: auto; min-width: 120px;"/>
    </a>

    <div class="d-flex align-items-center flex-shrink-0">
      <div class="mr-3 d-flex flex-row align-items-center">
        <div *ngIf="isLoginLinkVisible()">
          <button class="link p-0 m-0 border-0 bg-transparent text-white-50" type="button" (click)="onLogin()" aria-label="Login">
            <fa-icon [icon]="loginIcon" size="lg"></fa-icon>
          </button>
        </div>

        <div *ngIf="isLogoutLinkVisible()">
          <a href="#" class="text-white-50 text-decoration-none" (click)="onLogout()" aria-label="Logout">
            <fa-icon [icon]="logoutIcon" size="lg"></fa-icon>
          </a>
        </div>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        (click)="isCollapsed = !isCollapsed"
        aria-controls="navbarsExample02"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
  </div>

  <!-- Desktop Brand -->
  <a class="navbar-brand d-none d-lg-block" href="/">
    <img src="/assets/nztcs_logo.png" class="logo" alt="New Zealand Threat Classification System" title="New Zealand Threat Classification System"/>
  </a>

  <div class="collapse navbar-collapse w-100" id="navbarsExample02" [class.show]="!isCollapsed">
    <!-- Desktop menu -->
    <lib-menu-bar [mode]="'header'"></lib-menu-bar>

    <!-- Desktop menu -->
    <!--<ul class="navbar-nav ml-auto mr-4 d-none d-lg-flex">
      <li class="nav-item active">
        <a class="nav-link" routerLink="/home" routerLinkActive="active">Home <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item dropdown" dropdown>
        <a class="nav-link dropdown-toggle" id="usingDropdown" role="button" dropdownToggle aria-haspopup="true" aria-expanded="false" style="cursor: pointer;">
          Using NZTCS
        </a>
        <div class="dropdown-menu" *dropdownMenu aria-labelledby="usingDropdown">
          <a class="dropdown-item" routerLink="/content/CATEGORIES" routerLinkActive="active">Categories</a>
          <a class="dropdown-item" routerLink="/content/QUALIFIERS" routerLinkActive="active">Qualifiers</a>
          <a class="dropdown-item" routerLink="/assessment-export" routerLinkActive="active">Exports</a>
        </div>
      </li>
      <li class="nav-item dropdown" dropdown>
        <a class="na-link dvropdown-toggle" id="searchDropdown" role="button" dropdownToggle aria-haspopup="true" aria-expanded="false" style="cursor: pointer;">
          Search
        </a>
        <div class="dropdown-menu" *dropdownMenu aria-labelledby="searchDropdown">
          <a class="dropdown-item" routerLink="/report-search" routerLinkActive="active">Reports</a>
          <a class="dropdown-item" routerLink="/assessment-search" routerLinkActive="active">Assessments</a>
          <a class="dropdown-item" routerLink="/nztcs-species-search" routerLinkActive="active">Species</a>
          <a class="dropdown-item" routerLink="/nztcs-taxon-search" routerLinkActive="active">Taxa</a>
        </div>
      </li>
      <li class="nav-item dropdown" dropdown *ngIf="currentUser?.administrator || currentUser?.nameEditor">
        <a class="nav-link dropdown-toggle" id="adminDropdown" role="button" dropdownToggle aria-haspopup="true" aria-expanded="false" style="cursor: pointer;">
          Administration
        </a>
        <div class="dropdown-menu" *dropdownMenu aria-labelledby="adminDropdown">
          <a class="dropdown-item" routerLink="/attachment-search" routerLinkActive="active" *ngIf="currentUser?.administrator">Attachments</a>
          <a class="dropdown-item" routerLink="/batch-control" routerLinkActive="active" *ngIf="currentUser?.administrator">Batch</a>
          <a class="dropdown-item" routerLink="/code-value" routerLinkActive="active" *ngIf="currentUser?.administrator">Codes</a>
          <a class="dropdown-item" routerLink="/content-search" routerLinkActive="active" *ngIf="currentUser?.administrator">Content</a>
          <a class="dropdown-item" routerLink="/person-search" routerLinkActive="active" *ngIf="currentUser?.administrator">People</a>
          <a class="dropdown-item" routerLink="/tags" routerLinkActive="active" *ngIf="currentUser?.administrator">Tags</a>
          <a class="dropdown-item" routerLink="/name-match-search" routerLinkActive="active" *ngIf="currentUser?.nameEditor">NZOR</a>
          <a class="dropdown-item" routerLink="/menu-edit" routerLinkActive="active" *ngIf="currentUser?.administrator">Menu Edit</a>
        </div>
      </li>
    </ul>-->

    <!-- Mobile menu accordion -->
    <lib-menu-bar [mode]="'mobile'"></lib-menu-bar>

    <!-- Mobile menu accordion -->
    <!--<div class="d-lg-none w-100">
      <ul class="navbar-nav w-100">
        <li class="nav-item">
          <a class="nav-link" routerLink="/home" routerLinkActive="active" (click)="isCollapsed = true; isUsingCollapsed = true; isSearchCollapsed = true; isAdminCollapsed = true;">Home</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" (click)="toggleUsing()" role="button" [attr.aria-expanded]="!isUsingCollapsed" aria-controls="mobileUsing" style="cursor: pointer;">
            Using NZTCS
          </a>
          <div [collapse]="isUsingCollapsed" id="mobileUsing" class="mobile-accordion-menu">
            <ul class="nav flex-column pl-3">
              <li class="nav-item">
                <a class="nav-link" routerLink="/content/CATEGORIES" routerLinkActive="active" (click)="isCollapsed = true; isUsingCollapsed = true; isSearchCollapsed = true; isAdminCollapsed = true;">Categories</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" routerLink="/content/QUALIFIERS" routerLinkActive="active" (click)="isCollapsed = true; isUsingCollapsed = true; isSearchCollapsed = true; isAdminCollapsed = true;">Qualifiers</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" routerLink="/assessment-export" routerLinkActive="active" (click)="isCollapsed = true; isUsingCollapsed = true; isSearchCollapsed = true; isAdminCollapsed = true;">Exports</a>
              </li>
            </ul>
          </div>
        </li>

        <li class="nav-item">
          <a class="nav-link" (click)="toggleSearch()" role="button" [attr.aria-expanded]="!isSearchCollapsed" aria-controls="mobileSearch" style="cursor: pointer;">
            Search
          </a>
          <div [collapse]="isSearchCollapsed" id="mobileSearch" class="mobile-accordion-menu">
            <ul class="nav flex-column pl-3">
              <li class="nav-item">
                <a class="nav-link" routerLink="/report-search" routerLinkActive="active" (click)="isCollapsed = true; isUsingCollapsed = true; isSearchCollapsed = true; isAdminCollapsed = true;">Reports</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" routerLink="/assessment-search" routerLinkActive="active" (click)="isCollapsed = true; isUsingCollapsed = true; isSearchCollapsed = true; isAdminCollapsed = true;">Assessments</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" routerLink="/nztcs-species-search" routerLinkActive="active" (click)="isCollapsed = true; isUsingCollapsed = true; isSearchCollapsed = true; isAdminCollapsed = true;">Species</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" routerLink="/nztcs-taxon-search" routerLinkActive="active" (click)="isCollapsed = true; isUsingCollapsed = true; isSearchCollapsed = true; isAdminCollapsed = true;">Taxa</a>
              </li>
            </ul>
          </div>
        </li>

        <li class="nav-item" *ngIf="currentUser?.administrator || currentUser?.nameEditor">
          <a class="nav-link" (click)="toggleAdmin()" role="button" [attr.aria-expanded]="!isAdminCollapsed" aria-controls="mobileAdmin" style="cursor: pointer;">
            Administration
          </a>
          <div [collapse]="isAdminCollapsed" id="mobileAdmin" class="mobile-accordion-menu">
            <ul class="nav flex-column pl-3">
              <li class="nav-item" *ngIf="currentUser?.administrator">
                <a class="nav-link" routerLink="/attachment-search" routerLinkActive="active" (click)="isCollapsed = true; isUsingCollapsed = true; isSearchCollapsed = true; isAdminCollapsed = true;">Attachments</a>
              </li>
              <li class="nav-item" *ngIf="currentUser?.administrator">
                <a class="nav-link" routerLink="/batch-control" routerLinkActive="active" (click)="isCollapsed = true; isUsingCollapsed = true; isSearchCollapsed = true; isAdminCollapsed = true;">Batch</a>
              </li>
              <li class="nav-item" *ngIf="currentUser?.administrator">
                <a class="nav-link" routerLink="/code-value" routerLinkActive="active" (click)="isCollapsed = true; isUsingCollapsed = true; isSearchCollapsed = true; isAdminCollapsed = true;">Codes</a>
              </li>
              <li class="nav-item" *ngIf="currentUser?.administrator">
                <a class="nav-link" routerLink="/content-search" routerLinkActive="active" (click)="isCollapsed = true; isUsingCollapsed = true; isSearchCollapsed = true; isAdminCollapsed = true;">Content</a>
              </li>
              <li class="nav-item" *ngIf="currentUser?.administrator">
                <a class="nav-link" routerLink="/person-search" routerLinkActive="active" (click)="isCollapsed = true; isUsingCollapsed = true; isSearchCollapsed = true; isAdminCollapsed = true;">People</a>
              </li>
              <li class="nav-item" *ngIf="currentUser?.administrator">
                <a class="nav-link" routerLink="/tags" routerLinkActive="active" (click)="isCollapsed = true; isUsingCollapsed = true; isSearchCollapsed = true; isAdminCollapsed = true;">Tags</a>
              </li>
              <li class="nav-item" *ngIf="currentUser?.nameEditor">
                <a class="nav-link" routerLink="/name-match-search" routerLinkActive="active" (click)="isCollapsed = true; isUsingCollapsed = true; isSearchCollapsed = true; isAdminCollapsed = true;">NZOR</a>
              </li>
              <li class="nav-item" *ngIf="currentUser?.administrator">
                <a class="nav-link" routerLink="/menu-edit" routerLinkActive="active" (click)="isCollapsed = true; isUsingCollapsed = true; isSearchCollapsed = true; isAdminCollapsed = true;">Menu Edit</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>-->

    <!-- Desktop login/logout section -->
    <div class="mr-4 d-none d-lg-flex flex-column align-items-end flex-shrink-0 text-nowrap">
      <div *ngIf="isNameDisplayed() && currentUser">
        {{ currentUser.name }}
      </div>

      <div *ngIf="isLoginLinkVisible()">
        <button class="link d-flex align-items-center" type="button" (click)="onLogin()">
          <fa-icon [icon]="loginIcon" class="mr-1"></fa-icon> <span>Login</span>
        </button>
      </div>

      <div *ngIf="isLogoutLinkVisible()">
        <a href="#" class="d-flex align-items-center" (click)="onLogout()">
          <fa-icon [icon]="logoutIcon" class="mr-1"></fa-icon> <span>Logout</span>
        </a>
      </div>
    </div>
  </div>
</nav>

<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <ng-progress #progressBar color="#ff0000" [spinner]="false" aria-label="Page Loading Progress Bar"></ng-progress>

      <!-- Routed views go here -->
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<app-footer></app-footer>
